import React, { useEffect, useState } from "react";

import { ReactComponent as TitleIcon } from "../../../imgs/icons/chat.svg";
import Modal from "../../../components/Modal";
import CreateUpdateIntentModalBody from "../../../components/CreateUpdateIntentModalBody";

const defaultValues = {
  type: "",
  description: "",
  category: "Order Management",
  response: "",
  email_collect: true,
  hand_off: true,
  set_live: false,
};

const AddIntentModal = ({
  isOpen,
  onClose,
  onSuccess,
  setLoading,
  api,
  loading,
}) => {
  const [intent, setIntent] = useState(defaultValues);

  const actionDisabled =
    !intent.type || !intent.description || !intent.category || !intent.response;

  const handleInputChange = (field, value) => {
    setIntent(prevState => ({
      ...prevState,
      [field]: value,
    }));
  };

  const createIntent = async e => {
    try {
      e.preventDefault();

      setLoading(true);

      const chatbotUuid = localStorage.getItem("chatbot_uuid");

      await api.post("/api/intents", {
        ...intent,
        chatbot_uuid: chatbotUuid,
      });

      onSuccess();
    } catch (err) {
      console.error("Failed to create intent", err);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setIntent(defaultValues);
    }
  }, [isOpen]);

  return (
    <Modal
      isSubmitting={loading}
      disabled={actionDisabled}
      open={isOpen}
      onClose={onClose}
      onSubmit={createIntent}
      title="Add Intent"
      tooltip={
        <div className="max-w-sm">
          Intents are used by your AI Agent to understand a specific customer
          intent and how to react in those situations.
        </div>
      }
      startIcon={
        <TitleIcon width={45} height={45} className="p-2 border rounded-xl" />
      }
    >
      <CreateUpdateIntentModalBody
        handleInputChange={handleInputChange}
        intent={intent}
        showTooltips={isOpen}
      />
    </Modal>
  );
};

export default AddIntentModal;
